import type { TypeSetSelected } from '../types';

import { isEmpty } from '../../../general/isEmpty';

// ----------------------------------------------------------------------------

function setSelected(element: HTMLSelectElement, value: string | string[], config: TypeSetSelected = {}): void {
    const values = isEmpty(value) ? [] : Array.isArray(value) ? value : [value];

    const type = config.type ?? 'value';

    //
    if (element.multiple) {
        for (const elOption of element.options) {
            const match = values.includes(elOption[type]);

            elOption.selected = match;
        }
    }
    //
    else {
        let matched = false;

        for (const elOption of element.options) {
            const isMatch = !matched && values.includes(elOption[type]);

            elOption.selected = isMatch;

            if (isMatch) {
                matched = true;
            }
        }
    }

    //
    if (config.fireEvent === true) {
        element.dispatchEvent(new Event('change', { bubbles: true }));
    }
}

// ----------------------------------------------------------------------------

export default setSelected;
